<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Solicitação de notícia</span>
      </h1>
      <div>
        <PrimaryButton v-if="articleRequest.status == 'pending_author'" class="px-5" @click="catchArticle()" icon="fa-solid fa-pen-to-square">
          Produzir notícia
        </PrimaryButton>
        <PrimaryButton v-else-if="articleRequest.status == 'production' && articleRequest.id_user_catch == authStore.user.id" class="px-5" @click="submit()" icon="fa-solid fa-paper-plane">
          Enviar
        </PrimaryButton>
      </div>
    </div>
  </div>

  <div v-if="!loading" class="align p-4 space_title">
    <div class="row">
      <div :class="{ 'col-12': true, 'col-lg-8': articleRequest.image, 'mb-4': true}">
        <div class="card">
          <div class="p-4">
            <div class="row">

              <div v-if="articleRequest.status == 'production' && articleRequest.id_user_catch == authStore.user.id" class="col-12 mb-3">
                <InputText label="Informe a URL da notícia publicada" v-model="articleRequest.url_publish" :error="formErrors.url_publish" />
              </div>

              <div class="col-12 mb-3">
                <span class="badge" :style="'background-color: ' + articleRequest.status_color">{{ articleRequest.status_name }}</span>
              </div>

              <div v-if="articleRequest.status == 'available_panel'" class="col-12 mb-3">
                <strong>URL da notícia publicada</strong>
                <p>{{ articleRequest.url_publish }}</p>
              </div>

              <div class="col-12 mb-3">
                <strong>Título sugerido</strong>
                <p>{{ articleRequest.title }}</p>
              </div>

              <div class="col-12 mb-3">
                <strong>URL</strong>
                <p>{{ articleRequest.url }}</p>
              </div>

              <div class="col-12">
                <strong>Descrição</strong>
                <p>{{ articleRequest.content }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4" v-if="articleRequest.image">
        <div class="card">
          <div class="p-4">
            <div class="row">

              <img :src="articleRequest.image" />

              <div v-if="articleRequest.image_credits" class="col-12 mt-3">
                <strong>Créditos da imagem</strong>
                <p>{{ articleRequest.image_credits }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import RedirectBack from '@/components/RedirectBack.vue'

import { inject, onBeforeMount, onMounted, ref } from 'vue'
import { useArticleStore } from '@/stores/ArticleStore'

import { storeToRefs } from 'pinia'
import { useToast, TYPE } from "vue-toastification"
import { useRoute } from 'vue-router'
import InputText from '@/components/InputText.vue'
import { useAuthStore } from '@/stores/AuthStore'
import {errorFormat} from "@/utils/errorFormat";

const toast = useToast();
const loader = inject('$loader');
const loading = ref(false);
const processing = ref(false);

const route = useRoute();

const articleStore = useArticleStore();
const { articleRequest } = storeToRefs(articleStore);

const authStore = useAuthStore();

onBeforeMount(async () => {
  articleRequest.value = {};
  articleRequest.value.references = [null];
});

onMounted(async () => {
  const id = route.params.id;
  if (route.name == 'articleRequestView') {
    loader.show();
    loading.value = true;

    await articleStore.getArticleRequest(id);

    loader.hide();
    loading.value = false;
  }
});

const formErrors = ref({});

const catchArticle = async () => {
  if(processing.value == true){
    return;
  }

  loader.show();
  formErrors.value = {};
  processing.value = true;

  const formResult = await articleStore.catchArticleRequest(articleRequest.value.id);
  if (formResult.success) {
    toast('Solicitação enviada', { type: TYPE.SUCCESS, timeout: 6000 });
    articleStore.getArticleRequest(articleRequest.value.id);
  }
  else {
    formErrors.value = errorFormat(formResult.errors);

    if(formResult.message){
      toast(formResult.message, { type: TYPE.ERROR, timeout: 6000 });
    }
  }

  processing.value = false;
  loader.hide();
};

const submit = async () => {
  if(processing.value == true){
    return;
  }

  let params = {
    url_publish: articleRequest.value.url_publish,
  }

  loader.show();
  formErrors.value = {};
  processing.value = true;

  const formResult = await articleStore.updateArticleRequest(articleRequest.value.id, params);
  if (formResult.success) {
    toast('Solicitação atualizada', { type: TYPE.SUCCESS, timeout: 6000 });
    articleStore.getArticleRequest(articleRequest.value.id);
  }
  else {
    formErrors.value = errorFormat(formResult.errors);

    if(formResult.message){
      toast(formResult.message, { type: TYPE.ERROR, timeout: 6000 });
    }
  }

  processing.value = false;
  loader.hide();
};
</script>